import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import {
    AttorneyService,
    PortalConfigurationService,
} from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import CredentialsModal from "../../../queue/components/modals/CredentialsModal";
import { string32 } from "pdfjs-dist/types/src/shared/util";

export default function BlackListEmail({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    type obj = { email: string };

    const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const never = "never" as const;
    const [blackListEmails, setBlackListEmails] = useState(
        [] as APIModels.BlackListEmailResponse[]
    );

    const [selectedId, setSelectedId] = useState("");

    const [modalShow, setModalShow] = useState(false);
    const refreshData = () => {
        if (attorney.id != "") {
            AttorneyService.getBlackListEmail({
                attorneyId: attorney.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setBlackListEmails(resp.data!);
                    } else {
                        console.log("error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        AttorneyService.getBlackListEmail({
            attorneyId: attorney.id ?? "",
        }).then(
            (resp) => {
                if (resp.successful === true) {
                    setBlackListEmails(resp.data!);
                } else {
                    console.log("error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    const getRowId = (rowData: APIModels.PortalConfigurationRequest) => {
        setSelectedId(rowData.id!);
    };

    return (
        <div className="card text-center">
            <CredentialsModal
                show={modalShow}
                portalConfigId={selectedId}
                onClose={() => setModalShow(false)}
            />
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        options={{
                            pageSize: 10,
                            pageSizeOptions: [10],
                        }}
                        data={blackListEmails}
                        columns={[
                            {
                                title: "Email",
                                field: "email",
                                type: "string",

                                validate: (row) => ({
                                    isValid:
                                        row.email != undefined &&
                                        row.email!.match(isValidEmail) != null,
                                    helperText: "Please enter valid email",
                                }),
                            },
                        ]}
                        title="Black Listed Emails"
                        /*
                        actions={[
                            {
                                icon: "add_box",
                                tooltip: "Add",
                                isFreeAction: true,
                                onClick: (event) =>
                                    alert("You want to add a new row"),
                            },
                        ]}
                        */
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    if (blackListEmails.length < 10) {
                                        AttorneyService.addBlackListEmail({
                                            attorneyId: attorney.id ?? "",
                                            email: newData.email,
                                        }).then(
                                            (resp) => {
                                                refreshData();
                                                resolve(null);
                                            },
                                            (error) => {
                                                console.log(error);
                                                alert(error.message);
                                                resolve(null);
                                            }
                                        );
                                        resolve(null);
                                    } else {
                                        alert("Black List limit (10) reached.");
                                        resolve(null);
                                    }
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.updateBlackListEmail({
                                        attorneyId: attorney.id,
                                        oldEmail: oldData?.email,
                                        newEmail: newData.email,
                                    }).then(
                                        (resp) => {
                                            if (resp.successful == false) {
                                                alert(resp.errorMessage);
                                            }
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            alert(error.message);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.deleteBlackListEmail({
                                        attorneyId: attorney.id,
                                        email: oldData.email,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            alert(error.message);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
